import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ISalesByTimeOfDayApiService } from './sales-by-time-of-day-api.interface';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportSalesByTimeOfDayQueryDto } from './dtos/export-sales-by-time-of-day.query.dto';
import { FindSalesByTimeOfDayQueryDto } from './dtos/find-sales-by-time-of-day.query.dto';
import { FindSalesByTimeOfDayResponseDto } from './dtos/find-sales-by-time-of-day.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByTimeOfDayApiService implements ISalesByTimeOfDayApiService {
  private readonly ENDPOINT = 'time-of-day';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findSalesByTimeOfDay(
    query: FindSalesByTimeOfDayQueryDto
  ): Promise<FindSalesByTimeOfDayResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindSalesByTimeOfDayResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportSalesByTimeOfDay(
    query: ExportSalesByTimeOfDayQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
